import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { key: 2 }
const _hoisted_4 = { key: 3 }
const _hoisted_5 = ["href"]
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", null, "planning@travexploit.be", -1)
const _hoisted_7 = {
  key: 0,
  class: "ion-padding"
}
const _hoisted_8 = { class: "ion-padding" }
const _hoisted_9 = {
  key: 0,
  class: "ion-padding"
}
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { key: 1 }
const _hoisted_12 = { class: "ion-padding" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_back_button = _resolveComponent("ion-back-button")!
  const _component_ion_buttons = _resolveComponent("ion-buttons")!
  const _component_ion_title = _resolveComponent("ion-title")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_ion_header = _resolveComponent("ion-header")!
  const _component_UserChip = _resolveComponent("UserChip")!
  const _component_ion_text = _resolveComponent("ion-text")!
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_FilesPreview = _resolveComponent("FilesPreview")!
  const _component_SiteBlock = _resolveComponent("SiteBlock")!
  const _component_ion_col = _resolveComponent("ion-col")!
  const _component_ion_row = _resolveComponent("ion-row")!
  const _component_ion_grid = _resolveComponent("ion-grid")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_PlanningEntrySkeleton = _resolveComponent("PlanningEntrySkeleton")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_uploadable_file = _resolveComponent("uploadable-file")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_list = _resolveComponent("ion-list")!
  const _component_ion_input = _resolveComponent("ion-input")!
  const _component_ion_select_option = _resolveComponent("ion-select-option")!
  const _component_ion_select = _resolveComponent("ion-select")!
  const _component_ion_modal = _resolveComponent("ion-modal")!
  const _component_RelatedMessages = _resolveComponent("RelatedMessages")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_header, null, {
        default: _withCtx(() => [
          _createVNode(_component_ion_toolbar, { color: "primary" }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_buttons, { slot: "start" }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_back_button, {
                    text: _ctx.$t('planning.back_button_label'),
                    "default-href": "/planning"
                  }, null, 8, ["text"])
                ]),
                _: 1
              }),
              _createVNode(_component_ion_title, null, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.entry?.display_name), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      (_ctx.entry)
        ? (_openBlock(), _createBlock(_component_ion_content, { key: 0 }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_grid, { fixed: true }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_row, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_col, null, {
                        default: _withCtx(() => [
                          _createElementVNode("h1", null, [
                            (_ctx.moment(_ctx.entry.starts_at).format('LL')===_ctx.moment().format('LL'))
                              ? (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(_ctx.$t('calendar.today')), 1))
                              : (_ctx.moment(_ctx.entry.starts_at).format('LL')===_ctx.moment().subtract(1,'day').format('LL'))
                                ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(_ctx.$t('calendar.yesterday')), 1))
                                : (_ctx.moment(_ctx.entry.starts_at).format('LL')===_ctx.moment().add(1,'day').format('LL'))
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_ctx.$t('calendar.tomorrow')), 1))
                                  : (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_ctx.moment(_ctx.entry.starts_at).format('LL')), 1))
                          ]),
                          _createElementVNode("h2", null, _toDisplayString(_ctx.entry.task_name), 1),
                          _createElementVNode("div", null, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.compiled_roles, (role) => {
                              return (_openBlock(), _createBlock(_component_UserChip, {
                                key: role.user.uuid,
                                display_role: true,
                                role_data: role
                              }, null, 8, ["role_data"]))
                            }), 128))
                          ]),
                          _createElementVNode("div", {
                            class: _normalizeClass(_ctx.$style['spaced'])
                          }, [
                            _createVNode(_component_ion_text, { color: "medium" }, {
                              default: _withCtx(() => [
                                _createElementVNode("h3", null, _toDisplayString(_ctx.$t('planning.timeline.title')), 1)
                              ]),
                              _: 1
                            }),
                            _createElementVNode("div", {
                              class: _normalizeClass({
                [_ctx.$style['timeline']]: true,
                [_ctx.$style['is-'+_ctx.entry.status]]: _ctx.$style['is-'+_ctx.entry.status]
              })
                            }, [
                              _createElementVNode("div", {
                                class: _normalizeClass(_ctx.$style['hours'])
                              }, [
                                _createElementVNode("p", {
                                  class: _normalizeClass(_ctx.$style['hour'])
                                }, _toDisplayString(_ctx.moment(_ctx.entry.starts_at).format('LT')), 3),
                                (_ctx.entry.status==='to_review')
                                  ? (_openBlock(), _createElementBlock("button", {
                                      key: 0,
                                      class: _normalizeClass(_ctx.$style['hour']),
                                      onClick: _cache[0] || (_cache[0] = ($event: any) => {_ctx.edit_hours=true;_ctx.validation_step='files'})
                                    }, [
                                      _createTextVNode(_toDisplayString(_ctx.moment(_ctx.entry.ends_at).format('LT')) + " ", 1),
                                      _createVNode(_component_ion_icon, { icon: _ctx.chevronForwardOutline }, null, 8, ["icon"])
                                    ], 2))
                                  : (_openBlock(), _createElementBlock("p", {
                                      key: 1,
                                      class: _normalizeClass(_ctx.$style['hour'])
                                    }, _toDisplayString(_ctx.moment(_ctx.entry.ends_at).format('LT')), 3))
                              ], 2),
                              _createElementVNode("div", {
                                class: _normalizeClass(_ctx.$style['description'])
                              }, [
                                _createElementVNode("div", null, [
                                  _createElementVNode("p", {
                                    class: _normalizeClass(_ctx.$style['status'])
                                  }, _toDisplayString(_ctx.$t('planning.status.' + _ctx.entry.status)), 3),
                                  _createElementVNode("p", null, _toDisplayString(_ctx.entry.task_name), 1)
                                ])
                              ], 2)
                            ], 2)
                          ], 2),
                          (_ctx.entry.status==='blocked')
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 0,
                                class: _normalizeClass(_ctx.$style['spaced'])
                              }, [
                                _createVNode(_component_ion_text, { color: "danger" }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("h1", null, _toDisplayString(_ctx.$t('planning.review.title')), 1),
                                    _createElementVNode("p", null, _toDisplayString(_ctx.$t('planning.review.blocked')), 1),
                                    _createVNode(_component_ion_button, {
                                      color: "danger",
                                      size: "large",
                                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.validation_step='manual_validation'))
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_ctx.$t('planning.review.contact_button')), 1)
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ], 2))
                            : _createCommentVNode("", true),
                          (_ctx.entry.status==='to_review')
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 1,
                                class: _normalizeClass(_ctx.$style['spaced'])
                              }, [
                                _createElementVNode("h1", null, _toDisplayString(_ctx.$t('planning.review.title')), 1),
                                _createElementVNode("div", null, [
                                  _createVNode(_component_ion_button, {
                                    onClick: _cache[2] || (_cache[2] = ($event: any) => {_ctx.edit_hours=false;_ctx.validation_step='files'})
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(_ctx.$t('planning.review.yes')), 1)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_ion_button, {
                                    fill: "outline",
                                    onClick: _cache[3] || (_cache[3] = ($event: any) => {_ctx.edit_hours=true;_ctx.validation_step='files'})
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(_ctx.$t('planning.review.no')), 1)
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _createVNode(_component_ion_text, { color: "medium" }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("p", null, _toDisplayString(_ctx.$t('planning.review.disclaimer')), 1)
                                  ]),
                                  _: 1
                                })
                              ], 2))
                            : _createCommentVNode("", true),
                          (_ctx.user_is_validator&&_ctx.entry?.status==='changed')
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 2,
                                class: _normalizeClass(_ctx.$style['spaced'])
                              }, [
                                _createElementVNode("h1", null, _toDisplayString(_ctx.$t('planning.review.title')), 1),
                                _createVNode(_component_ion_button, {
                                  color: "success",
                                  onClick: _ctx.save
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.$t('planning.review.validate')), 1)
                                  ]),
                                  _: 1
                                }, 8, ["onClick"]),
                                _createVNode(_component_ion_button, {
                                  color: "success",
                                  fill: "outline",
                                  onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.validation_step='edit_hours'))
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.$t('planning.review.validator_edit_hours')), 1)
                                  ]),
                                  _: 1
                                })
                              ], 2))
                            : _createCommentVNode("", true),
                          (_ctx.entry?.files?.length)
                            ? (_openBlock(), _createBlock(_component_FilesPreview, {
                                key: 3,
                                files: _ctx.entry?.files,
                                class: "ion-padding"
                              }, null, 8, ["files"]))
                            : _createCommentVNode("", true),
                          _createElementVNode("div", {
                            class: _normalizeClass(_ctx.$style['spaced'])
                          }, [
                            (_ctx.entry?.site)
                              ? (_openBlock(), _createBlock(_component_SiteBlock, {
                                  key: 0,
                                  site: _ctx.entry.site
                                }, null, 8, ["site"]))
                              : _createCommentVNode("", true)
                          ], 2)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : (_openBlock(), _createBlock(_component_ion_content, { key: 1 }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_grid, { fixed: true }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_row, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_col, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_PlanningEntrySkeleton)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })),
      (_ctx.entry?.status==='changed'||_ctx.entry?.status==='to_review'||_ctx.entry?.status==='blocked')
        ? (_openBlock(), _createBlock(_component_ion_modal, {
            key: 2,
            "is-open": _ctx.validation_step,
            onCanDismiss: ($event: any) => (true),
            onWillDismiss: _cache[12] || (_cache[12] = ($event: any) => (_ctx.validation_step=false))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_header, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_toolbar, null, {
                    default: _withCtx(() => [
                      (_ctx.validation_step)
                        ? (_openBlock(), _createBlock(_component_ion_title, { key: 0 }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.entry?.task_name) + " (" + _toDisplayString(_ctx.moment(_ctx.entry.starts_at).format('L')) + ") — " + _toDisplayString(_ctx.entry?.site?.name), 1)
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      _createVNode(_component_ion_buttons, { slot: "end" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_button, {
                            onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.validation_step=false))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.entry?.status === 'blocked' || _ctx.entry?.status === 'changed' ? _ctx.$t('global.close') : _ctx.$t('global.cancel')), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              (_ctx.validation_step==='manual_validation')
                ? (_openBlock(), _createBlock(_component_ion_content, {
                    key: 0,
                    class: "ion-padding"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("a", {
                        class: _normalizeClass(_ctx.$style['email-info']),
                        href: 'mailto:' + ['planning@travexploit.be', ..._ctx.site_supervisors.map(supervisor=>supervisor.email)].join(',')
                      }, [
                        _createVNode(_component_ion_icon, {
                          icon: _ctx.mailUnreadOutline,
                          color: "primary"
                        }, null, 8, ["icon"]),
                        _hoisted_6,
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.site_supervisors, (supervisor) => {
                          return (_openBlock(), _createElementBlock("p", {
                            key: supervisor.uuid
                          }, [
                            _createElementVNode("span", null, _toDisplayString(supervisor.email), 1)
                          ]))
                        }), 128))
                      ], 10, _hoisted_5)
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (_ctx.validation_step==='files')
                ? (_openBlock(), _createBlock(_component_ion_content, { key: 1 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_text, {
                        align: "center",
                        color: "primary"
                      }, {
                        default: _withCtx(() => [
                          (_ctx.task_assignee)
                            ? (_openBlock(), _createElementBlock("h4", _hoisted_7, _toDisplayString(_ctx.$t('planning.review.' + _ctx.validation_step + '.subtitle')), 1))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_list, null, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList([..._ctx.planningDataset.required_files,..._ctx.planningDataset.files], (file) => {
                            return (_openBlock(), _createBlock(_component_ion_item, { key: file }, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_label, null, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.$t('planning.review.' + _ctx.validation_step + '.' + file + '_file') + (!_ctx.planningDataset.required_files.includes(file) ? ' (' + _ctx.$t('global.optional').toLowerCase() + ')' : '')), 1)
                                  ]),
                                  _: 2
                                }, 1024),
                                _createVNode(_component_uploadable_file, {
                                  params: {related: _ctx.entry.uuid, type:file},
                                  value: _ctx.files[file],
                                  accept: "image/*",
                                  capture: "environment",
                                  multiple: "true",
                                  onChange: ($event: any) => (_ctx.setFile($event, file))
                                }, null, 8, ["params", "value", "onChange"])
                              ]),
                              _: 2
                            }, 1024))
                          }), 128))
                        ]),
                        _: 1
                      }),
                      _createElementVNode("div", _hoisted_8, [
                        _createVNode(_component_ion_button, {
                          disabled: !_ctx.files_uploaded,
                          color: "success",
                          expand: "block",
                          onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.edit_hours?_ctx.validation_step='edit_hours':_ctx.save))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t('planning.review.' + _ctx.validation_step + '.validate')), 1)
                          ]),
                          _: 1
                        }, 8, ["disabled"])
                      ])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (_ctx.validation_step==='edit_hours')
                ? (_openBlock(), _createBlock(_component_ion_content, { key: 2 }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", null, [
                        _createVNode(_component_ion_text, {
                          align: "center",
                          color: "primary"
                        }, {
                          default: _withCtx(() => [
                            (_ctx.task_assignee)
                              ? (_openBlock(), _createElementBlock("h4", _hoisted_9, _toDisplayString(_ctx.$t('planning.review.edit_hours.subtitle')) + " " + _toDisplayString(_ctx.task_assignee?.display_name) + " ? ", 1))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_ion_item, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_label, null, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.$t('planning.review.edit_hours.starts_at')), 1)
                              ]),
                              _: 1
                            }),
                            _createElementVNode("div", {
                              slot: "end",
                              class: _normalizeClass(_ctx.$style['hours-table-value'])
                            }, [
                              _createVNode(_component_ion_input, {
                                modelValue: _ctx.starts_at_hour,
                                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.starts_at_hour) = $event)),
                                step: (15*60),
                                type: "time"
                              }, null, 8, ["modelValue"])
                            ], 2)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_ion_item, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_label, null, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.$t('planning.review.edit_hours.ends_at')), 1)
                              ]),
                              _: 1
                            }),
                            _createElementVNode("div", {
                              slot: "end",
                              class: _normalizeClass(_ctx.$style['hours-table-value'])
                            }, [
                              _createVNode(_component_ion_input, {
                                modelValue: _ctx.ends_at_hour,
                                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.ends_at_hour) = $event)),
                                step: (15*60),
                                type: "time"
                              }, null, 8, ["modelValue"])
                            ], 2)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_ion_item, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_label, null, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.$t('planning.review.edit_hours.pause_duration')), 1)
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_ion_select, {
                              value: _ctx.pause_duration,
                              interface: "popover",
                              onIonChange: _cache[9] || (_cache[9] = ($event: any) => (_ctx.pause_duration=$event.detail.value))
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(this.planningDataset.break_durations, (duration) => {
                                  return (_openBlock(), _createBlock(_component_ion_select_option, {
                                    key: duration,
                                    value: duration
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(duration) + " " + _toDisplayString(_ctx.$t('calendar.minutes')), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["value"]))
                                }), 128))
                              ]),
                              _: 1
                            }, 8, ["value"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_ion_item, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_label, null, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.$t('planning.review.edit_hours.duration')), 1)
                              ]),
                              _: 1
                            }),
                            _createElementVNode("div", {
                              slot: "end",
                              class: _normalizeClass(_ctx.$style['hours-table-value'])
                            }, [
                              (_ctx.total_duration>0)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(_ctx.moment.utc().startOf('day').add(_ctx.total_duration, 'minutes').format('LT')), 1))
                                : (_openBlock(), _createElementBlock("span", _hoisted_11, [
                                    _createVNode(_component_ion_text, { color: "danger" }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_ctx.moment.utc().startOf('day').add(0, 'minutes').format('LT')), 1)
                                      ]),
                                      _: 1
                                    })
                                  ]))
                            ], 2)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_ion_item, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_label, null, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.$t('planning.review.edit_hours.changed_reason')), 1)
                              ]),
                              _: 1
                            }),
                            _createElementVNode("div", {
                              slot: "end",
                              class: _normalizeClass(_ctx.$style['hours-table-value'])
                            }, [
                              (!_ctx.changed_comment)
                                ? (_openBlock(), _createBlock(_component_ion_button, {
                                    key: 0,
                                    onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.show_messages=true))
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(_ctx.$t('planning.review.edit_hours.changed_reason_button')), 1)
                                    ]),
                                    _: 1
                                  }))
                                : (_openBlock(), _createBlock(_component_ion_button, {
                                    key: 1,
                                    color: "light",
                                    onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.show_messages=true))
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(_ctx.changed_comment), 1)
                                    ]),
                                    _: 1
                                  }))
                            ], 2)
                          ]),
                          _: 1
                        }),
                        _createElementVNode("div", _hoisted_12, [
                          _createVNode(_component_ion_button, {
                            disabled: _ctx.total_duration<=0,
                            color: "success",
                            expand: "block",
                            onClick: _ctx.save
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$t('planning.review.edit_hours.validate')), 1)
                            ]),
                            _: 1
                          }, 8, ["disabled", "onClick"])
                        ])
                      ])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["is-open"]))
        : _createCommentVNode("", true),
      (_ctx.entry?.uuid)
        ? (_openBlock(), _createBlock(_component_ion_modal, {
            key: 3,
            "is-open": _ctx.show_messages,
            onCanDismiss: ($event: any) => (true),
            onWillDismiss: _cache[14] || (_cache[14] = ($event: any) => (_ctx.show_messages=false))
          }, {
            default: _withCtx(() => [
              (0)
                ? (_openBlock(), _createBlock(_component_ion_header, { key: 0 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_toolbar, null, {
                        default: _withCtx(() => [
                          (_ctx.validation_step)
                            ? (_openBlock(), _createBlock(_component_ion_title, { key: 0 }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.entry?.task_name), 1)
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true),
                          _createVNode(_component_ion_buttons, { slot: "end" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_button, {
                                onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.show_messages=false))
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.$t('global.close')), 1)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              _createVNode(_component_ion_content, null, {
                default: _withCtx(() => [
                  (_ctx.show_messages)
                    ? (_openBlock(), _createBlock(_component_RelatedMessages, {
                        key: 0,
                        related: _ctx.entry.uuid,
                        onMessage_sent: _ctx.commentSubmit
                      }, null, 8, ["related", "onMessage_sent"]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["is-open"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}